<ng-container *ngIf="passenger">
  <div class="font-body-1 medium-type">
    {{ 'passenger.' + asPaxTypeKey(passenger.passengerTypeCode).toLowerCase() | finLocalization | titlecase }}
  </div>

  <div class="capitalize" data-hj-suppress>
    <span>{{ 'paxDetails.fields.firstName.label' | finLocalization }}:</span> {{ passenger.firstName }}
  </div>

  <div class="capitalize" data-hj-suppress>
    <span>{{ 'paxDetails.fields.lastName.label' | finLocalization }}:</span> {{ passenger.lastName }}
  </div>

  <div class="nordic-blue-900-text capitalize" *ngIf="accompanyingAdult" data-hj-suppress>
    {{
      'passengerReview.withAdult'
        | finLocalization: { withAdultFullName: accompanyingAdult.firstName + ' ' + accompanyingAdult.lastName }
    }}
  </div>

  <div class="nordic-blue-900-text capitalize" *ngIf="accompanyingInfant" data-hj-suppress>
    {{
      'passenger.withInfant'
        | finLocalization: { withInfantFullName: accompanyingInfant.firstName + ' ' + accompanyingInfant.lastName }
    }}
  </div>

  <div *ngIf="passenger.dateOfBirth || showEmpty">
    <span>{{ 'passengerReview.dateOfBirth' | finLocalization }}</span>
    <ng-container *ngIf="passenger.dateOfBirth; else empty">
      {{ passenger.dateOfBirth | finDateFormat: 'DATE' }}</ng-container
    >
  </div>

  <ng-container *ngIf="passenger.frequentFlyerCards?.length > 0 || showEmpty">
    <div *ngFor="let card of passenger.frequentFlyerCards" data-test-cards data-hj-suppress>
      <span
        >{{
          (card ? getFrequentFlyerLabel(card) : '')
            | finLocalization
            | finEmpty: ('purchase.review.frequentFlyer.default' | finLocalization)
        }}:</span
      >
      <ng-container *ngIf="card; else empty"> {{ card.cardNumber }}</ng-container>
    </div>
  </ng-container>

  <div *ngIf="passenger.email || showEmpty" data-hj-suppress>
    <span> {{ 'passengerReview.email' | finLocalization }}</span
    ><ng-container *ngIf="passenger.email; else empty"> {{ passenger.email | lowercase }}</ng-container>
  </div>

  <div *ngIf="passenger.phoneNumbers?.length > 0 || showEmpty" data-hj-suppress>
    <span class="valign-top">
      {{
        (passenger.phoneNumbers?.length > 1 ? 'passengerReview.phonePlural' : 'passengerReview.phone') | finLocalization
      }}
    </span>
    <ul *ngIf="passenger.phoneNumbers?.length > 0; else empty" class="unstyled inline-block">
      <li *ngFor="let phone of passenger.phoneNumbers">+{{ phone?.countryPrefix }} {{ phone?.number }}</li>
    </ul>
  </div>

  <div *ngIf="passenger.etickets?.length > 0 && showEtickets">
    <span class="valign-top"> {{ 'manageMyBooking.label.eTicketNumber' | finLocalization }}: </span>
    <ul class="unstyled inline-block">
      <li *ngFor="let ticket of passenger.etickets">{{ ticket.id }}</li>
    </ul>
  </div>

  <ng-template #empty>
    <span aria-hidden="true"> -</span>
    <span class="is-vishidden">{{ 'passengerReview.empty' | finLocalization }}</span>
  </ng-template>
</ng-container>
